import { connect } from "react-redux";
import { GelDragDropQuestion as Component } from "@learningblocks/storybook-components";
import {
  onGelUpdate,
  onDropDownUpdate,
  onGelSelect,
  onCloseFeedback,
  onGelSubmit,
  onGelReset,
} from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    onGelUpdate: (data) => {
      dispatch(onGelUpdate(data));
    },
    onDropDownUpdate: (data) => {
      dispatch(onDropDownUpdate(data));
    },
    onGelSelect: (data) => {
      dispatch(onGelSelect(data));
    },
    closeFeedback: (data) => {
      dispatch(onCloseFeedback(data));
    },
    onSubmit: (data) => {
      dispatch(onGelSubmit(data));
    },
    onReset: (data) => {
      dispatch(onGelReset(data));
    },
  };
}

export const GelDragDropQuestion = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
